import BaseMapper from '../../BaseMapper';

const CategoryMapper = (data, context) => {
    return data;
};

export default CategoryMapper;
